// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------
import { useState } from "react";
import { Card, Modal, Button, notification, Typography } from "antd";

// -------------------------------------------------------------------------------
// Components
// -------------------------------------------------------------------------------
import { Heading4, Paragraph14 } from "themes/default/_typography";
import { TrashIcon, VisaIcon } from "components/Icons";

// -------------------------------------------------------------------------------
// Store
// -------------------------------------------------------------------------------
import { useStripeDetachPaymentMethodMutation } from "store/api/api";

// -------------------------------------------------------------------------------
// Utils, Styles and Assets
// -------------------------------------------------------------------------------
import StyledPaymentMethodCard from "./styles";

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
const PaymentMethodCard = ({ className, paymentMethod, refetch, ...other }) => {
	const [detachPaymentMethodTrigger, detachPaymentMethod] = useStripeDetachPaymentMethodMutation();
	const [confirmOpen, setConfirmOpen] = useState(false);

	const handleDetachPaymentMethod = async () => {
		try {
			await detachPaymentMethodTrigger({ payment_method_id: paymentMethod.id }).unwrap();

			// Refetch the payment methods after detaching with a delay to accept Stripe Webhook on the backend
			setTimeout(() => {
				refetch?.();
				setConfirmOpen(false);
			}, 700);
		} catch (error) {
			notification.error({
				message: "There was an error detaching the payment method",
			});
		}
	};

	return (
		<StyledPaymentMethodCard className={`${className} sb-payment-method-card`} {...other}>
			<Modal
				title="Confirm"
				open={confirmOpen}
				onCancel={() => setConfirmOpen(false)}
				footer={
					<div className="sb-confirm-form__actions">
						<Button onClick={() => setConfirmOpen(false)}>Go Back</Button>
						<Button loading={detachPaymentMethod.isLoading} onClick={handleDetachPaymentMethod} type="primary">
							Yes
						</Button>
					</div>
				}
			>
				<Typography.Paragraph style={{ marginBottom: 16 }}>
					Are you sure you want to detach this payment method?
				</Typography.Paragraph>
			</Modal>

			<Card hoverable>
				<div className="sb-payment-method-card__inner">
					<div className="sb-payment-method-card__inner__left">
						<div className="sb-payment-method-card__inner__left__icon">
							<VisaIcon />
						</div>
						<div className="sb-payment-method-card__inner__left__data">
							<Heading4>**** **** **** {paymentMethod?.card_last4 || 1234}</Heading4>
							<Paragraph14>
								Expires {paymentMethod.card_exp_month || 12}/{paymentMethod.card_exp_year || 2021}
							</Paragraph14>
						</div>
					</div>
					<div className="sb-payment-method-card__inner__right">
						<div className="sb-payment-method-card__inner__right__action">
							<TrashIcon
								onClick={() => {
									setConfirmOpen(true);
								}}
							/>
						</div>
					</div>
				</div>
			</Card>
		</StyledPaymentMethodCard>
	);
};

export default PaymentMethodCard;

